import type { ISbRichtext } from '@storyblok/js/dist/types/types';
import { renderRichText, RichTextSchema, storyblokInit } from '@storyblok/js';
import { pageSpecificCMSBannerOptions } from '@app/stores/banners';

export const getOptimizedCmsImageUrl = (filename: string, size?: string, format?: string) => {
	return `${filename}/m/${size}${format ? `/filters:format(${format})` : ''}`;
};

// Docs: https://github.com/storyblok/storyblok-js-client/blob/v4/source/schema.js
// 		 https://github.com/storyblok/storyblok-js
const customSchema = RichTextSchema;
customSchema.marks.bold = () => ({ tag: 'strong' });

storyblokInit();

export const richTextToHTML = (richText: ISbRichtext) => {
	return renderRichText(richText, { schema: customSchema });
};

export const checkCMSBanner = (CMSBanner) => {
	if (CMSBanner && CMSBanner.length && CMSBanner[0].isOpen) {
		pageSpecificCMSBannerOptions.set({
			...CMSBanner[0],
			message: richTextToHTML(CMSBanner[0].message)
		});
	} else {
		pageSpecificCMSBannerOptions.set(undefined);
	}
};
